import type { Indicator, ScoringLevel } from '@/lib/schema/types';
import { IndicatorRow } from './IndicatorRow';
import { ratingLevel } from '@/lib/schema/loader';
import { cn } from '@/lib/utils';

export function IndicatorColumn({
  itemId,
  level,
  indicators,
  fullyYes,
}: {
  itemId: string;
  level: ScoringLevel;
  indicators: Indicator[];
  fullyYes: boolean;
}) {
  const meta = ratingLevel(level);
  return (
    <section
      aria-labelledby={`column-${level}`}
      data-level={level}
      className="flex flex-col rounded-md border bg-card"
    >
      <header
        id={`column-${level}`}
        className={cn(
          'flex items-center justify-between border-b px-3 py-2 text-sm font-semibold text-white',
        )}
        style={{ backgroundColor: `var(--level-bg)` }}
      >
        <span>
          {meta?.label ?? 'Level'} ({level})
        </span>
        {fullyYes && (
          <span className="rounded-full bg-white/20 px-2 py-0.5 text-[11px] uppercase tracking-wide">
            All Yes
          </span>
        )}
      </header>
      <div className="flex flex-1 flex-col divide-y divide-border/40 p-1">
        {indicators.map((ind) => (
          <IndicatorRow key={ind.id} itemId={itemId} indicator={ind} />
        ))}
      </div>
    </section>
  );
}
